import { get } from '../../../services/request';

export const getEquityTypeDropdown = () => get('Common/GetEquityTypeForDropdown');
